import React, { Suspense, useEffect, useState } from 'react';
import { Spin } from 'antd';
import { BASE_URL } from "../Components/Constant";
import PluginLoader from "../Components/PluginLoader";
import { useParams } from 'react-router-dom';
const CustomComponentRender = () => {



    const [plugins, setPlugins] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { component_name } = useParams();




    useEffect(() => {
        // if (!component.selectedComponentName) return;
        const fetchPlugins = async () => {
            setLoading(true);
            setError(null);

            try {
                const res = await fetch(
                    `${BASE_URL}/plugins/retrieve?name=${component_name}`
                );

                if (!res.ok) throw new Error("Failed to fetch plugin");

                const data = await res.json();
                setPlugins(Array.isArray(data) ? data : [data]);
            } catch (err) {
                console.error("Failed to load plugins", err);
                setPlugins([]);
                setError(err.message || "Unknown error");
            } finally {
                setLoading(false);
            }
        };

        fetchPlugins();
    }, [component_name]); // ONLY run when name changes



    return (

        <Suspense fallback={<Spin size="large" />}>
            {plugins.map((plugin) => (
                <PluginLoader 
                  manifest={plugin} 
                  key={plugin.name}
                  propsFromHost={{ recordId: "YOUR_HARDCODED_RECORD_ID" }}
                />
            ))}
        </Suspense>
    );
}

export default CustomComponentRender;